<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>

<!--              <el-form-item label="分红ID">-->
<!--                  <el-input  v-model="queryForm.incomeId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="发放ID">-->
<!--                  <el-input  v-model="queryForm.sendId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="当天日期">
                  <el-input style="width: 177px;" v-model="queryForm.dayDate"></el-input>
              </el-form-item>
              <el-form-item label="我的分红金额">
                  <el-input style="width: 177px;" v-model="queryForm.sendMoney"></el-input>
              </el-form-item>
              <el-form-item label="总的分红金额">
                  <el-input style="width: 177px;" v-model="queryForm.totalMoney"></el-input>
              </el-form-item>
              <el-form-item label="我拥有积分数量">
                  <el-input style="width: 177px;" v-model="queryForm.currentScore"></el-input>
              </el-form-item>
              <el-form-item label="总积分数量">
                  <el-input style="width: 177px;" v-model="queryForm.totalScore"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelTeamIncomeUserRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelTeamIncomeUserRecord"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editModelTeamIncomeUserRecord(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelTeamIncomeUserRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshModelTeamIncomeUserRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelTeamIncomeUserRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="incomeId"-->
<!--        label="分红ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--        <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="sendId"-->
<!--        label="发放ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendMoney"
        label="我的分红金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalMoney"
        label="总的分红金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentScore"
        label="我拥有积分数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalScore"
        label="总积分数量"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkModelTeamIncomeUserRecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editModelTeamIncomeUserRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteModelTeamIncomeUserRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelTeamIncomeUserRecordStates[modelTeamIncomeUserRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="modelTeamIncomeUserRecord"
          ref="modelTeamIncomeUserRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label=""-->
<!--            prop="id"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncomeUserRecord.id"-->
<!--              :disabled="modelTeamIncomeUserRecordState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="分红ID"-->
<!--            prop="incomeId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncomeUserRecord.incomeId"-->
<!--              :disabled="modelTeamIncomeUserRecordState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="modelTeamIncomeUserRecord.userId"-->
<!--              :disabled="modelTeamIncomeUserRecordState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="modelTeamIncomeUserRecordState == 'check'"
                           labelValue="id" :value="modelTeamIncomeUserRecord.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncomeUserRecord.dayDate"-->
<!--              :disabled="modelTeamIncomeUserRecordState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style='width: 177px'
                  v-model='modelTeamIncomeUserRecord.dayDate'
                  :disabled="modelTeamIncomeUserRecordState == 'check'"
                  type='date'
                  format='yyyy-MM-dd'
                  value-format='yyyy-MM-dd'
                  placeholder='选择日期'>
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="我的分红金额"
            prop="sendMoney"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncomeUserRecord.sendMoney"
              :disabled="modelTeamIncomeUserRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总的分红金额"
            prop="totalMoney"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncomeUserRecord.totalMoney"
              :disabled="modelTeamIncomeUserRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="我拥有积分数量"
            prop="currentScore"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncomeUserRecord.currentScore"
              :disabled="modelTeamIncomeUserRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总积分数量"
            prop="totalScore"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncomeUserRecord.totalScore"
              :disabled="modelTeamIncomeUserRecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelTeamIncomeUserRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelTeamIncomeUserRecordList();
                    this.getModelTeamIncomeUserRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelTeamIncomeUserRecordList();
                    this.getModelTeamIncomeUserRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     incomeId: '', //分红ID
                     sendId: '',
                     userId: '', //用户
                     dayDate: '', //当天日期
                     sendMoney: '', //我的分红金额
                     totalMoney: '', //总的分红金额
                     currentScore: '', //我拥有积分数量
                     totalScore: '', //总积分数量
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelTeamIncomeUserRecordState: 'add',
                modelTeamIncomeUserRecordStates: {
                    add: '新建发放用户',
                    check: '查看发放用户',
                    edit: '修改发放用户'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                modelTeamIncomeUserRecordList: [],
                modelTeamIncomeUserRecord: {
                    id: '', //
                    incomeId: '', //分红ID
                    sendId: '',
                    userId: '', //用户
                    dayDate: '', //当天日期
                    sendMoney: '', //我的分红金额
                    totalMoney: '', //总的分红金额
                    currentScore: '', //我拥有积分数量
                    totalScore: '', //总积分数量
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    incomeId: [{ required: true, message: '分红ID不能为空', trigger: 'blur' }],
                    sendId: [{ required: true, message: '发放ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    dayDate: [{ required: true, message: '当天日期不能为空', trigger: 'blur' }],
                    sendMoney: [{ required: true, message: '我的分红金额不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '总的分红金额不能为空', trigger: 'blur' }],
                    currentScore: [{ required: true, message: '我拥有积分数量不能为空', trigger: 'blur' }],
                    totalScore: [{ required: true, message: '总积分数量不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            // this.getModelTeamIncomeUserRecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(incomeId, sendId){
                this.modelTeamIncomeUserRecord.incomeId = incomeId;
                this.modelTeamIncomeUserRecord.sendId = sendId;
                this.queryForm.incomeId = incomeId;
                this.queryForm.sendId = sendId;
                this.getModelTeamIncomeUserRecordList();
            },
            getValueUser(value) {
                this.modelTeamIncomeUserRecord.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            resetModelTeamIncomeUserRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelTeamIncomeUserRecordList = [];
            },
            resetDialog() {
                this.modelTeamIncomeUserRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      incomeId: this.queryForm.incomeId, //分红ID
                      sendId: this.queryForm.sendId,
                      userId: '', //用户
                      dayDate: '', //当天日期
                      sendMoney: '', //我的分红金额
                      totalMoney: '', //总的分红金额
                      currentScore: '', //我拥有积分数量
                      totalScore: '', //总积分数量
                };
                this.getModelTeamIncomeUserRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelTeamIncomeUserRecord = {
                      id: '', //
                      incomeId: this.modelTeamIncomeUserRecord.incomeId, //分红ID
                      sendId: this.modelTeamIncomeUserRecord.sendId,
                      userId: '', //用户
                      dayDate: '', //当天日期
                      sendMoney: '', //我的分红金额
                      totalMoney: '', //总的分红金额
                      currentScore: '', //我拥有积分数量
                      totalScore: '', //总积分数量
                };
            },
            submitForm() {
                if (this.modelTeamIncomeUserRecordState == 'add') {
                    this.$refs.modelTeamIncomeUserRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/teamincomeuserrecord/add`,{ ...this.modelTeamIncomeUserRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelTeamIncomeUserRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelTeamIncomeUserRecordState == 'edit') {
                    this.$refs.modelTeamIncomeUserRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.modelTeamIncomeUserRecord.user;
                            post(`/model/teamincomeuserrecord/edit`,{ ...this.modelTeamIncomeUserRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelTeamIncomeUserRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelTeamIncomeUserRecord() {
                this.showDialog = true;
                this.modelTeamIncomeUserRecordState = 'add';
            },
            checkModelTeamIncomeUserRecord(modelTeamIncomeUserRecordId) {
                console.log(modelTeamIncomeUserRecordId);
                this.currentModelTeamIncomeUserRecordId = modelTeamIncomeUserRecordId;

                this.getModelTeamIncomeUserRecordById();
                this.showDialog = true;
                this.modelTeamIncomeUserRecordState = 'check';
            },
            editModelTeamIncomeUserRecord(modelTeamIncomeUserRecordId) {
                console.log('modelTeamIncomeUserRecord', modelTeamIncomeUserRecordId);
                if (modelTeamIncomeUserRecordId) {
                    this.currentModelTeamIncomeUserRecordId = modelTeamIncomeUserRecordId;
                    this.getModelTeamIncomeUserRecordById();
                } else {
                    this.modelTeamIncomeUserRecord = { ...this.modelTeamIncomeUserRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelTeamIncomeUserRecordState = 'edit';
            },
            deleteModelTeamIncomeUserRecord(modelTeamIncomeUserRecordId) {
                let ids = '';
                if (modelTeamIncomeUserRecordId) {
                    ids = modelTeamIncomeUserRecordId;
                } else {
                    ids = this.multipleSelection.map((modelTeamIncomeUserRecord) => modelTeamIncomeUserRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/teamincomeuserrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelTeamIncomeUserRecordList();
                                this.getModelTeamIncomeUserRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelTeamIncomeUserRecordList() {
                this.resetModelTeamIncomeUserRecordList();
                this.getModelTeamIncomeUserRecordList();
            },
            getModelTeamIncomeUserRecordList(query = {}) {
                this.loading = true;
                get(`/model/teamincomeuserrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelTeamIncomeUserRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelTeamIncomeUserRecordById() {
                get(`/model/teamincomeuserrecord/get`,{ id: this.currentModelTeamIncomeUserRecordId }).then((res) =>{
                    if(res.success){
                      this.modelTeamIncomeUserRecord = { ...this.modelTeamIncomeUserRecord, ...res.modelTeamIncomeUserRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelTeamIncomeUserRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/model/teamincomeuserrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/teamincomeuserrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/teamincomeuserrecord/importData`,formData);
              this.refreshModelTeamIncomeUserRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelTeamIncomeUserRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelTeamIncomeUserRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>